import * as React from 'react';

import { Title } from 'components/common/Title';
import { stepStyles as styles } from 'components/steps/commonStyles';
import { Configuration as ConfigurationStep, ConfigurationProps } from 'components/steps/Configuration';
import { useContext } from 'react';
import TranslationsContext from 'translations/TranslationsContext';
import translationKeys from 'translationKeys';

export const Configuration = (props: ConfigurationProps) => {
	const { t } = useContext(TranslationsContext)!;
	return (
		<ConfigurationStep {...props}>
			<Title id='form-title'>{t(translationKeys.EnvChecker.Configuration.Step.Title)}</Title>
			<p className={styles.formElement}>{t(translationKeys.EnvChecker.Configuration.Step.Paragraph.First)}</p>
			<p className={styles.formElement}>{t(translationKeys.EnvChecker.Configuration.Step.Paragraph.Second)}</p>
			<div className={styles.line} />
		</ConfigurationStep>);
};
